'use strict';

const svg4everybody = require('svg4everybody');
const Router = require('./Router');
const Utils = require('utils/Utils.js');
const $ = require('jquery');
const primaryInput = require('detect-it').primaryInput;

require('style.less');
require('components/SectionBlock/SectionBlock');

svg4everybody();
window.$ = $;
const mediaQueries = [
    {
        label: 'desktop',
        rule: '(min-width: 768px)'
    },
    {
        label: 'mobile',
        rule: '(max-width: 767px)'
    }
];
// for active/hovers on touch/mouse devices
document.documentElement.classList.add(primaryInput === 'touch' ? 'isTouch' : 'isPointer');

//fix for hovers|active on mobile, what a weird behavior!
//fastclick solves this problem, but adds a bunch of other
if (primaryInput === 'touch') {
    document.addEventListener('touchstart', function () {}, {passive: true});
}

window.app.utils = Utils;
window.app.isTouch = primaryInput === 'touch';
window.app.isPointer = primaryInput !== 'touch';


const setScrollBarWidth = () => {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

    document.body.appendChild(outer);

    const widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = 'scroll';

    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);

    const widthWithScroll = inner.offsetWidth;
    outer.parentNode.removeChild(outer);

    document.documentElement.style.setProperty('--scrollbar-width', widthNoScroll - widthWithScroll + 'px');
};

const onWindowResize = () => {
    const isDesktop = window.matchMedia(
        mediaQueries[0].rule
    ).matches;
    const ww = document.body.clientWidth;
    const w = isDesktop ? 1440 : 767;
    document.documentElement.style.fontSize = (1440 * ww) / w + 'px';
};

setScrollBarWidth();
window.addEventListener('resize', onWindowResize);
onWindowResize();


(new Router()).start();
